import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {CapitalizePipe} from '../../../core/pipes/capitalize.pipe';
import {MatTooltip} from '@angular/material/tooltip';
import {ActivatedRoute, RouterLink, UrlSegment} from '@angular/router';
import {TypeOfEstimation} from '../side-bar/type-of-estimation';
import {NgClass} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {UserService} from '../../../core/services/user.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {AccessService, guideKeys} from '../../../core/services/access.service';
import {MatDialog} from '@angular/material/dialog';
import {AccountComponent} from './account/account.component';

@Component({
  selector: 'ostso-side-bar-double',
  standalone: true,
  imports: [
    CapitalizePipe,
    MatTooltip,
    RouterLink,
    NgClass,
    MatIcon,
    MatProgressSpinner
  ],
  templateUrl: './side-bar-double.component.html',
  styleUrl: './side-bar-double.component.scss'
})
export class SideBarDoubleComponent implements OnInit {
  _type: RegistrType = 'remarktype';
  @Input() titleCreate: string = 'Создать заявку';
  @Output() toggle = new EventEmitter();
  @Output() clickOutside = new EventEmitter();
  @Input() opened = false;

  @Input() set type(value: string) {
    const mapSet: Record<string, UserRightsKeys> = {
      group: 'rategroup',
      subgroup: 'ratesubgroup',
      kind: 'ratekind',
      remarktype: 'remarktype',
      ratecategory: 'ratecategory',
    } as const;
    this._type = mapSet[value];
  }


  menuRights: Record<UserRightsKeys, boolean> | null = null;

  get isSomeMenuRigtsTrue(): boolean | null {
    return this.menuRights && Object.values(this.menuRights).some(Boolean);
  }

  get newURL(): string {
      return `/${ this.route.snapshot.url[0].path}/new`;
  }

  @HostListener('document:click', ['$event']) docClick(event: MouseEvent): void {
    const isSelfTarget = (event.target as HTMLElement).closest('mat-sidenav');
    if (isSelfTarget) return;
    this.clickOutside.emit();
  }

  isGrade = false; //для скрытия кнопки "создать" на grade компоненте
  isNewEnabled = false;
  canButtonCreateGrade = false;//для скрытия кнопки в зависимости от прав доступа

  constructor(
    public typeOfEstimation: TypeOfEstimation,
    public user: UserService,
    public route: ActivatedRoute,
    public accessService: AccessService,
    private dialog: MatDialog,
  ) {
    this.route.url.subscribe((url: UrlSegment[]) => {
      if ((['group', 'subgroup', 'kind', 'remarktype', 'ratecategory', 'ratecard', 'institutions', 'facility', 'users']).includes(url[0].path)) {
        this.accessService.newButton.subscribe(v => {
          this.isNewEnabled = v[url[0].path as guideKeys];
          this.canButtonCreateGrade = !url[0].path.includes('ratecard') && v['ratecard'] && this.accessService.role && this.accessService.role.some(r=>r.code ==='inspector');
        });
      }
      console.log({url: url[0].path});
    });
  }

  toggleEmit(): void {
    this.toggle.emit();
  }

  ngOnInit(): void {
    if (!this.user.value.lastName && !this.user.value.firstName) {
      this.user.fetchUser().subscribe(user => {
        user.rights?.watch && (this.menuRights = user.rights.watch);
      });
    } else {
      this.menuRights = this.user.rights.watch;
    }

    this.route.url.subscribe(url => {
      this.isGrade = url[0].path.includes('grade');
    });
  }


  openAccount(value: User): void {
    this.dialog.open(AccountComponent, {
      width: '35vw',
      height: '100svh',
      position: {right: '0px'},
      data: value
    });
  }
}
